import React from "react";
import {useTheme} from "connectui/theme/ThemeProvider";
import {buildStyles} from "connectui/component/buildStyles";
import Container from "connectui/component/layout/Container";
import FlexContainer from "connectui/component/layout/FlexContainer";
import Text from "connectui/component/display/Text";
import SvgIcon from "connectui/component/display/SvgIcon";
import ICONS from "connectui/icons/iconMap";
import ButtonIcon from "connectui/component/input/button/ButtonIcon";
import GuestDetailsPanel from "./GuestDetailsPanel";
import {useTranslation} from "react-i18next";

const useStyles = (theme) =>
  buildStyles({
    container: {
      width: "100%",
      height: "100%",
      overflow: "hidden",
      minWidth: "370px",
      maxWidth: "450px",
    },
    header: {
      width: "100%",
      marginTop: theme.spacing(4),
      padding: theme.spacing(0, 4),
      marginBottom: theme.spacing(4),
    },
    contentContainer: {
      padding: theme.spacing(0, 4),
      height: "calc(100% - 56px)",
      overflowY: "auto",
      width: "100%",
    },
  });

const StandaloneGuestDetailsPanel = ({guestId, onClose}) => {
  const {theme} = useTheme();
  const classes = useStyles(theme);
  const {t} = useTranslation();

  return (
    <FlexContainer className={classes.container} flexDirection="column">
      <FlexContainer
        className={classes.header}
        gap={theme.spacing(3)}
        alignItems="center"
      >
        <FlexContainer
          justifyContent="space-between"
          alignItems="center"
          sx={{width: "100%"}}
        >
          <Text variant="displayXS" weight="semibold">
            {t("Guest Details")}
          </Text>
          <ButtonIcon
            icon={
              <SvgIcon
                component={ICONS["layout-sidebar-right"]}
                sx={{
                  width: "28px",
                  height: "28px",
                  padding: "5px",
                  color: theme.colors.textSecondary,
                }}
              />
            }
            sx={{
              borderRadius: theme.spacing(2),
              cursor: "pointer",
              padding: 0,
              border: "none",
              backgroundColor: "transparent",
              marginTop: "3px",
              "&:hover": {backgroundColor: theme.colors.hoverGray},
            }}
            onClick={onClose}
          />
        </FlexContainer>
      </FlexContainer>
      <Container className={classes.contentContainer}>
        <GuestDetailsPanel guestId={guestId} fullDetails={true} />
      </Container>
    </FlexContainer>
  );
};

export default StandaloneGuestDetailsPanel;
